export const useDevice = () => {
  const isMobile = useState<boolean>("isMobile", () => false);

  // Always re-apply UA on the server. A bare useState('isMobile') elsewhere
  // (e.g. layout) can create the key without this factory and leave SSR stuck on desktop.
  if (import.meta.server) {
    const headers = useRequestHeaders();
    const userAgent = headers["user-agent"] || "";
    isMobile.value = /mobile|android|iphone/i.test(userAgent);
  }

  const isDesktop = computed(() => !isMobile.value);

  return { isMobile, isDesktop };
};
